import axios from "axios"

export const initAxios = ()=>{
    axios.defaults.baseURL=process.env.NODE_ENV==="development"?"http://localhost:5000":""
    axios.defaults.withCredentials = true
    axios.defaults.headers.common['content-type'] = "application/json"
}
